<template>
  <div class="sh-input-container">
    <a-popover
      :title="popoverTitle"
      trigger="hover"
      placement="top"
      :visible="popoverVisible && hasData"
    >
      <template slot="content">
        <div class="popover-content">
          <div class="popover-row" v-if="horasExtras > 0">
            <span class="popover-label">Extras:</span>
            <span class="popover-value extra">+{{ horasExtras }}h</span>
          </div>
          <div class="popover-row" v-if="horasRecargoNocturno > 0">
            <span class="popover-label">Rec. Nocturno:</span>
            <span class="popover-value">{{ horasRecargoNocturno }}h</span>
          </div>
          <div class="popover-row" v-if="horasRecargoFestivoDiurno > 0">
            <span class="popover-label">Rec. Fest. Diurno:</span>
            <span class="popover-value">{{ horasRecargoFestivoDiurno }}h</span>
          </div>
          <div class="popover-row" v-if="horasRecargoFestivoNocturno > 0">
            <span class="popover-label">Rec. Fest. Nocturno:</span>
            <span class="popover-value">{{ horasRecargoFestivoNocturno }}h</span>
          </div>
          <template v-if="marcacionesConDatos.length">
            <div class="popover-section-label">Marcaciones entrada / salida</div>
            <div
              v-for="(m, idx) in marcacionesConDatos"
              :key="idx"
              class="popover-row popover-row-horizontal"
            >
              <span class="popover-label">#{{ idx + 1 }}</span>
              <span class="popover-value-inline">
                <span class="popover-time">Entrada {{ m.fecha_hora_inicio !== null ? formatHora(m.fecha_hora_inicio) : "❌" }}</span>
                <span class="popover-sep">—</span>
                <span class="popover-time">Salida {{ m.fecha_hora_fin !== null ? formatHora(m.fecha_hora_fin) : "❌" }}</span>
                 <span class="popover-sep">&nbsp;</span>
                <span class="popover-label">Estado Marcación: {{ m.estado_marcacion }}</span>
              </span>
            </div>
          </template>
          <template v-else>
            <div class="popover-row" v-if="fechaHoraInicio">
              <span class="popover-label">Entrada:</span>
              <span class="popover-value">{{ formatHora(fechaHoraInicio) }}</span>
            </div>
            <div class="popover-row" v-if="fechaHoraFin">
              <span class="popover-label">Salida:</span>
              <span class="popover-value">{{ formatHora(fechaHoraFin) }}</span>
            </div>
          </template>
          <!--<div class="popover-row" v-if="estadoMarcacion">
              <span class="popover-label">Marcación:</span>
              <span class="popover-value">{{ estadoMarcacion }}</span>
            </div>-->
          <div class="popover-row popover-turno-programado">
            <div class="popover-section-label">Turno programado</div>
            <div class="popover-value-html" v-html="turnoProgramado !== '' ? turnoProgramado : 'SIN TURNO PROGRAMADO'"></div>
          </div>
        </div>
      </template>

      <span class="sh-input-wrapper">
        <a-dropdown :trigger="['contextmenu']" @visibleChange="onDropdownVisibleChange">
          <a-menu slot="overlay">
            <a-menu-item v-if="!tieneTurnoProgramado" key="agregar-turno" @click="agregarTurno">
              <a-icon type="plus" style="color:darkblue"/>
              Agregar turno
            </a-menu-item>
            <a-menu-item v-if="tieneTurnoProgramado" key="editar-turno" @click="editarTurno">
              <a-icon type="edit" style="color:darkblue"/>
              Editar turno
            </a-menu-item>
            <a-menu-item v-if="tieneTurnoProgramado" key="eliminar-turno" @click="eliminarTurno">
              <a-icon type="delete" style="color:red"/>
              Eliminar turno
            </a-menu-item>
          </a-menu>
            <a-badge :dot="festivo">
            <a-badge :dot="domingo">
              <div
                class="sh-input-cell"
                :class="cellClass"
                @mouseenter="popoverVisible = true"
                @mouseleave="popoverVisible = false"
              >
                <span class="horas-display" v-if="hasData">
                  {{ displayValue }}
                </span>
                <span class="horas-display empty" v-else>
                  -
                </span>
              </div>
            </a-badge>
          </a-badge>
        </a-dropdown>
      </span>
    </a-popover>
  </div>
</template>

<script>
export default {
  props: {
    horasTrabajadas: {
      type: Number,
      default: 0
    },
    horasEsperadas: {
      type: Number,
      default: 0
    },
    estadoCumplimiento: {
      type: String,
      default: null
    },
    estadoMarcacion: {
      type: String,
      default: null
    },
    festivo: {
      type: Boolean,
      default: false
    },
    domingo: {
      type: Boolean,
      default: false
    },
    horasExtras: {
      type: Number,
      default: 0
    },
    horasFaltantes: {
      type: Number,
      default: 0
    },
    horasRecargoNocturno: {
      type: Number,
      default: 0
    },
    horasRecargoFestivoDiurno: {
      type: Number,
      default: 0
    },
    horasRecargoFestivoNocturno: {
      type: Number,
      default: 0
    },
    saldoDia: {
      type: Number,
      default: 0
    },
    fechaHoraInicio: {
      type: String,
      default: null
    },
    fechaHoraFin: {
      type: String,
      default: null
    },
    marcaciones: {
      type: Array,
      default: () => []
    },
    turnoProgramado: {
      type: String,
      default: null
    },
    tieneTurnoProgramado: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      popoverVisible: false
    }
  },
  computed: {
    marcacionesConDatos () {
      if (!Array.isArray(this.marcaciones)) return []
      return this.marcaciones.filter(
        m => m && (m.fecha_hora_inicio || m.fecha_hora_fin || m.estado_marcacion)
      )
    },
    hasData () {
      const tieneHoras = this.horasEsperadas > 0 || this.horasTrabajadas > 0
      const tieneTurnoProgramado = this.turnoProgramado && String(this.turnoProgramado).trim() !== ''
      return tieneHoras || tieneTurnoProgramado
    },
    displayValue () {
      return `${this.horasTrabajadas}h`
    },
    popoverTitle () {
      let title = 'Detalle del día'
      if (this.festivo) {
        title += ' (Festivo)'
      } else if (this.domingo) {
        title += ' (Domingo)'
      }
      return title
    },
    tieneMarcacionNoCompleta () {
      if (!Array.isArray(this.marcaciones) || this.marcaciones.length === 0) return false
      return this.marcaciones.some(
        m => m && String(m.estado_marcacion || '').toUpperCase().trim() !== 'COMPLETA'
      )
    },
    cellClass () {
      const classes = []

      /* Domingos y festivos no se pintan de color, solo muestran el badge */
      if (this.hasData) {
        const tolerancia = this.$getConfigValue('TOLERANCIA_OPC_TURNOS_HORAS', 5)

        if (this.horasTrabajadas > 0 && (Math.abs(this.horasEsperadas - this.horasTrabajadas) <= tolerancia)) {
          classes.push('cumplido')
        } else if (this.horasEsperadas > 0 && (this.horasTrabajadas > this.horasEsperadas)) {
          classes.push('parcial')
        } else if (this.horasTrabajadas === 0 && this.horasEsperadas > 0) {
          classes.push('incumplido')
        } else if (this.horasEsperadas === 0 && this.horasTrabajadas > 0) {
          classes.push('incumplido2')
        } else if (this.horasTrabajadas > 0 && (this.horasTrabajadas < this.horasEsperadas)) {
          classes.push('incumplido')
        }

      }

      /* Borde rojo si alguna marcación del día tiene estado distinto de COMPLETA */
      if (this.tieneMarcacionNoCompleta) {
        classes.push('incumplido')
      }

      return classes
    }
  },
  methods: {
    formatHora (fechaHora) {
      if (!fechaHora) return ''
      return moment(fechaHora).format('HH:mm')
    },
    agregarTurno () {
      this.$emit('click')
    },
    editarTurno () {
      this.$emit('edit')
    },
    eliminarTurno () {
      this.$emit('delete')
    },
    onDropdownVisibleChange () {
      this.popoverVisible = false
    }
  }
}
</script>

<style scoped>
.sh-input-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.sh-input-wrapper {
  display: inline-block;
}

.sh-input-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 50px;
  height: 28px;
  padding: 2px 6px;
  border-radius: 5px;
  background-color: transparent;
  border: 2px solid #d9d9d9;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
}

.sh-input-cell:hover {
  border-color: #1890ff;
  box-shadow: 0 0 4px rgba(24, 144, 255, 0.3);
}

.sh-input-cell.cumplido {
  border-color: #52c41a;
  border-width: 2px;
}

.sh-input-cell.cumplido .horas-display {
  color: #237804;
  font-weight: 600;
}

.sh-input-cell.parcial {
  border-color: #faad14;
  border-width: 2px;
}

.sh-input-cell.parcial .horas-display {
  color: #d48806;
  font-weight: 600;
}

.sh-input-cell.incumplido {
  border-color: #ff4d4f;
  border-width: 2px;
}

.sh-input-cell.incumplido .horas-display {
  color: #cf1322;
  font-weight: 600;
}

.sh-input-cell.incumplido2 {
  border-color: #b874ff;
  border-width: 2px;
}

.sh-input-cell.incumplido2 .horas-display {
  color: #9055d3;
  font-weight: 600;
}

.horas-display {
  font-weight: 500;
  color: #262626;
}

.horas-display.empty {
  color: #bfbfbf;
}

.popover-content {
  min-width: 180px;
}

.popover-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid #f0f0f0;
}

.popover-row:last-child {
  border-bottom: none;
}

.popover-label {
  color: #8c8c8c;
  font-size: 12px;
}

.popover-value {
  font-weight: 600;
  color: #262626;
  font-size: 12px;
}

.popover-value.extra {
  color: #52c41a;
}

.popover-value.faltante {
  color: #ff4d4f;
}

.popover-section-label {
  font-weight: 600;
  font-size: 12px;
  color: #262626;
  padding: 6px 0 4px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 4px;
}

.popover-row-horizontal {
  display: flex;
  align-items: center;
  gap: 8px;
}

.popover-value-inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
  font-weight: 600;
  font-size: 12px;
  color: #262626;
}

.popover-time {
  white-space: nowrap;
}

.popover-sep {
  color: #8c8c8c;
  font-weight: 400;
  margin: 0 2px;
}

.popover-turno-programado {
  flex-direction: column;
  align-items: stretch;
  padding-top: 8px;
}

.popover-value-html {
  font-size: 12px;
  color: #262626;
  line-height: 1.4;
}

.popover-value-html >>> b {
  color: #8c8c8c;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ShiftsManagement/ScheduledHoursInput.vue